import React, { useEffect, useState } from 'react';
import Alert from "../../../utils/Alert.js";
import { qcRequest, serviceAcceptanceRequest, visibilityRequest } from '../../../services/servicesServices';

const Visibility = ({ rowData }) => {
    const [isChecked, setIsChecked] = useState(false);

    useEffect(() => {
        setIsChecked(rowData.is_visible_for_contractors)
    }, [])

    const handleCheckBoxChange = async (event) => {
        const checked = event.target.checked;
        setIsChecked(checked);
        try {
            const response = await visibilityRequest(rowData.code, checked);
            if (response.status === 200) {
                window.location.reload();
            }
        } catch (error) {
            Alert("خطا", "در ارسال درخواست مشکلی به وجود آمده", "error");
        }
    }
    return (
        <span>      
            <form>
                <input 
                    type='checkbox' 
                    id='visibility' 
                    name='visibility' 
                    checked={isChecked} 
                    // disabled={!rowData.qc_is_enable}
                    onChange={handleCheckBoxChange} 
                />
            </form>
        </span>  
    );
}

export default Visibility;
